import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    getStockEv() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/stockev/`
        })
      )
        .then(res => {
          this.$store.commit("loading", false);
          return res.data;
        })
        .catch(err => {
          dispatchError(this.$store, err.message);
          throw err;
        });
    },
    getMinStock(gtin) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/types/${gtin}/minstock/`
        })
      )
        .then(res => {
          this.$store.commit("loading", false);
          return res.data;
        })
        .catch(err => {
          dispatchError(this.$store, err.message);
          throw err;
        });
    },
    updateMinStock(id, data) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + `/minstock/${id}/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
